import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {booleanAttribute, ChangeDetectionStrategy, Component, input, OnDestroy, OnInit, signal} from "@angular/core";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {TranslateModule} from "@ngx-translate/core";
import {EksterneLenker} from "felles-ng2/tjenester/EksterneLenker";
import {fadeInnAnimasjon} from "web-ng2/delt/animasjoner";

const debug = initDebugger('TipsKomponent');


/** Viser brukerrettet tips. */
@Component({
    selector: 'tips',
    templateUrl: './tips.html',
    styleUrls: ['./tips.scss'],
    animations: [fadeInnAnimasjon()],
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TipsKomponent implements OnInit, OnDestroy {

    constructor(private eksterneLenker: EksterneLenker /*private $timeout: ITimeoutService, private tipsTjeneste: TipsTjeneste*/) {
        // this.initSkalVises();
    }

    /** Dersom sann forsinkes visning av tipset 2 sekunder */
    forsinketVisning = input(false, {transform: booleanAttribute});
    /** Nøkkel benyttet for å registrere at tips er vist */
    noekkel = input<string | null>(null);
    /** Styrer hvordan tipses vises */
    stil = input<'liten' | 'stor' | 'inline'>('liten');
    /** ikke vis rekken med handlinger som vises når stil=stor */
    skjulTipshandling = input(false, {transform: booleanAttribute});

    skalVises = signal(false);

    private forsinketVisningTimerId: number | undefined = undefined;

    get tipslenke() {
        return this.eksterneLenker.hjemmesider.møteledelse;
    }

    skjul() {
        this.skalVises.set(false);
        /*@todo mangler implementasjon*/
        // this.tipsTjeneste.markerSomVist(this.noekkel);
    }

    ngOnInit(): void {
        if (this.forsinketVisning()) this.initForsinketVisning();
        else this.initSkalVises();
    }

    ngOnDestroy(): void {
        clearTimeout(this.forsinketVisningTimerId);
    }

    // $onChanges(changes: angular.IOnChangesObject): void {
    //     dersomChangesInneholder(changes, 'forsinketVisning', forsinketVisning => {
    //         this.forsinketVisning = forsinketVisning === 'true';
    //         if (this.forsinketVisning && !this.noekkel) this.initForsinketVisning();
    //     });
    // }

    //hjelpemetoder

    private initSkalVises() {
        /*@todo mangler implementasjon*/
        if (erTomEllerNil(this.noekkel())) {
            this.skalVises.set(true);
            return;
        }
        //  this.tipsTjeneste.erVist(this.noekkel).then(vist => {
        //      if (!vist) this.initForsinketVisning();
        //  });
    }

    private initForsinketVisning() {
        this.forsinketVisningTimerId = window.setTimeout(() => this.skalVises.set(true), 2000);
    }
}

